import React from 'react';

import asArray from 'utils/arrays/asArray.util';

const ShowTags = ({ hideName, tagList }) => (
  <div data-bem="ShowTags" className="tags-layout like-icon">
    <div data-bem="ShowTags__list" className="tags-list">
      {asArray(tagList).map(({ id, name, emoticon }) => (
        <div data-bem="ShowTags__item" className="tag-button tag-icon " key={id}>
          <div data-bem="ShowTags__emoticon" className="emoticon">
            {emoticon}
          </div>

          {!hideName && (
            <div data-bem="ShowTags__name" className="label-name">
              {name}
            </div>
          )}
        </div>
      ))}
    </div>
  </div>
);

export default ShowTags;
